@if (errorText) {
    <ion-text color="danger">{{ errorText }}</ion-text>
}
